var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-select-container"},_vm._l((_vm.options),function(option){return _c('button',{staticClass:"box-select-option border text-muted bg-none border-r-25 ml-2",class:_vm.isSelected(option.id)
        ? 'selected'
        : 'btn-outline-dark' + ' ' + _vm.getAdditionalClass(option),on:{"click":function($event){return _vm.select(option.id)}}},[_c('span',[_vm._v(_vm._s(option.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }